import { type ActionArgs } from 'xstate';

import * as AdjustSDK from '../utils/adjust-sdk';
import { AdjustEvent } from './adjust-initialization-machine.events';

function initialize() {
  throw new Error(
    'Provide an initialize function by calling `getAdjustInitializer` with the telemetry tracker function.',
  );
}

const syncCustomer: AdjustInitializationMachineAction = ({ event }) => {
  AdjustSDK.syncCustomer(event.type === 'SYNC_CUSTOMER' ? event.userId : null);
};

export const AdjustInitializationActions = {
  initialize,
  enable: AdjustSDK.enable,
  disable: AdjustSDK.disable,
  clearCustomer: AdjustSDK.clearCustomer,
  syncCustomer,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type AdjustInitializationMachineAction<ActionParams extends Record<string, unknown> | void = void> =
  (actionArgs: ActionArgs<{}, AdjustEvent, AdjustEvent>, params: ActionParams) => void;
